import axios from "axios";
import React, { useRef, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

function Upload() {
  const { id } = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showLimitMessage, setShowLimitMessage] = useState(false);
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const handleGalleryClick = () => {
    if (selectedImages.length >= 10) {
      setShowLimitMessage(true);
      setTimeout(() => setShowLimitMessage(false), 3000); // Hide message after 3 seconds
      return;
    }

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      // Calculate how many more images can be added
      const remainingSlots = 10 - selectedImages.length;

      if (remainingSlots <= 0) {
        setShowLimitMessage(true);
        setTimeout(() => setShowLimitMessage(false), 3000); // Hide message after 3 seconds
        return;
      }

      // Convert FileList to Array and limit to remaining slots
      const newFiles = Array.from(files).slice(0, remainingSlots);

      // Create object URLs for preview
      const newImages = newFiles.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));

      setSelectedImages((prevImages) => [...prevImages, ...newImages]);

      // If we've reached the limit, show a message
      if (selectedImages.length + newFiles.length >= 10) {
        setShowLimitMessage(true);
        setTimeout(() => setShowLimitMessage(false), 3000); // Hide message after 3 seconds
      }
    }
  };

  const removeImage = (index) => {
    setSelectedImages((prevImages) => {
      // Revoke the object URL to prevent memory leaks
      URL.revokeObjectURL(prevImages[index].preview);

      // Create a new array without the removed image
      return prevImages.filter((_, i) => i !== index);
    });
  };

  const handleUpload = () => {
    setSending(true);
    // TODO: Implement the actual upload logic here
    //console.log("Uploading images:", selectedImages);
    let data = new FormData();
    data.append("galleryId", id);

    // data.append('images', fs.createReadStream('/'));
    selectedImages.forEach((image) => {
      data.append("images", image.file);
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://api.suko.space/api/images/upload",
      // url: "http://192.168.1.62:4000/api/images/upload",
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setSelectedImages([]);
        setSent(true);
        setSending(false);
      })
      .catch((error) => {
        console.log("ERROR?", error);
        setSent(false);
        setSending(false);
        setError(error.message);
      });
  };

  // Clean up object URLs when component unmounts
  React.useEffect(() => {
    return () => {
      selectedImages.forEach((image) => {
        URL.revokeObjectURL(image.preview);
      });
    };
  }, []);

  return (
    <div style={{ height: "100%" }}>
      {sent ? (
        <div style={{ textAlign: "center" }}>
          <h1>Fotos enviadas correctamente</h1>
        </div>
      ) : (
        <>
          <div style={{ textAlign: "center" }}>
            <h1>Subir fotos</h1>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              padding: "20px",
              overflowY: "auto",
            }}
          >
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*"
              multiple
              style={{ display: "none" }}
              max="10"
            />

            {showLimitMessage && (
              <div
                style={{
                  position: "fixed",
                  top: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#ff6b6b",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  zIndex: 1000,
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              >
                Máximo 10 imágenes permitidas
              </div>
            )}

            {selectedImages.length === 0 ? (
              <>
                <div
                  id="gallery-button"
                  style={{
                    width: "90%",
                    fontSize: "1.5rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "150px",
                    border: "4px solid #9EC6F3",
                    backgroundColor: "#9EC6F3",
                    borderRadius: "25px",
                    marginBottom: "20px",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  onClick={handleGalleryClick}
                >
                  <div>
                    {`Click para seleccionar `}
                    <span style={{ fontWeight: "bold" }}>
                      máximo 10 imágenes  
                    </span>
                    </div>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    marginBottom: "20px",
                    alignItems: "center",
                  }}
                >
                  <h2>Imágenes seleccionadas ({selectedImages.length}/10)</h2>
                  <button
                    onClick={handleGalleryClick}
                    style={{
                      padding: "10px 20px",
                      backgroundColor:
                        selectedImages.length >= 10 ? "#cccccc" : "#9EC6F3",
                      border: "none",
                      borderRadius: "5px",
                      cursor:
                        selectedImages.length >= 10 ? "not-allowed" : "pointer",
                      opacity: selectedImages.length >= 10 ? 0.7 : 1,
                    }}
                    disabled={selectedImages.length >= 10}
                  >
                    {selectedImages.length >= 10
                      ? "Límite alcanzado"
                      : "Añadir más"}
                  </button>
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(150px, 1fr))",
                    gap: "15px",
                    width: "100%",
                    marginBottom: "20px",
                  }}
                >
                  {selectedImages.map((image, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <img
                        src={image.preview}
                        alt={`Preview ${index}`}
                        style={{
                          width: "100%",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                      <button
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "rgba(255, 0, 0, 0.7)",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "30px",
                          height: "30px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        X
                      </button>
                    </div>
                  ))}
                </div>

                {sending ? (
                  <div
                    style={{
                      padding: "15px 30px",
                      backgroundColor: "#c4c4c4",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      fontSize: "1.2rem",
                      cursor: "pointer",
                      marginTop: "20px",
                      marginBottom: "40px",
                    }}
                  >
                    Enviando...
                  </div>
                ) : (
                  <button
                    onClick={handleUpload}
                    style={{
                      padding: "15px 30px",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      fontSize: "1.2rem",
                      cursor: "pointer",
                      marginTop: "20px",
                      marginBottom: "40px",
                    }}
                  >
                    Enviar fotos
                  </button>
                )}
              </>
            )}
          </div>
        </>
      )}
      <div
        style={{
          display: "flex",
          gap: "1rem",
          bottom: "15px",
          left: "15px",
          position: "fixed",
          width: "70%",
          backgroundColor: "#9EC6F3",
          borderTop: "1px solid #e0e0e0",
          borderRadius: "30px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            width: "100%",
            cursor: "pointer",
            height: "50px",
          }}
          onClick={() => navigate(`/gallery/${id}`)}
        >
          <Link
            to={`/gallery/${id}`}
            style={{
              color: "black",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              fontWeight: "bold",
              textDecoration: "none",
            }}
          >
            Volver a galería
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Upload;
